// docs: https://github.com/altostra/type-validations#readme
import { enumOf, objectOf } from "@altostra/type-validations";

// Mirrors the onboarding_status GET response shape; the enum matches `OnboardingStatus`.
export const isPostCustomObjectsEnableAccountsResult = objectOf({
  status: enumOf("not_started", "queued", "provisioning", "applying_recipe", "ready", "failed"),
});
